import { render } from "./Test.vue?vue&type=template&id=92b6a540&scoped=true&ts=true"
import script from "./Test.vue?vue&type=script&lang=ts"
export * from "./Test.vue?vue&type=script&lang=ts"

import "./Test.vue?vue&type=style&index=0&id=92b6a540&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92b6a540"]])

export default __exports__